/*
 * Heaer Messages
 *
 * This contains all the text for the Heaer container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Heaer';

export default defineMessages({
  welcomeText: {
    id: `${scope}.welcomeText`,
    defaultMessage: 'Welcome to Actively',
  },
  eventHome: {
    id: `${scope}.eventHome`,
    defaultMessage: 'Events',
  },
  eventTeamList: {
    id: `${scope}.eventTeamList`,
    defaultMessage: 'Team list',
  },
  eventVolunteerList: {
    id: `${scope}.eventVolunteerList`,
    defaultMessage: 'Volunteer list',
  },
  eventMemberList: {
    id: `${scope}.eventMemberList`,
    defaultMessage: 'Walker list',
  },
  eventSupporterList: {
    id: `${scope}.eventSupporterList`,
    defaultMessage: 'Supporter list',
  },
  eventVolunteerDetail: {
    id: `${scope}.eventVolunteerDetail`,
    defaultMessage: 'Volunteer detail',
  },
  memberDetail: {
    id: `${scope}.memberDetail`,
    defaultMessage: 'Member detail',
  },
  profile: {
    id: `${scope}.profile`,
    defaultMessage: 'Profile',
  },
  logout: {
    id: `${scope}.logout`,
    defaultMessage: 'Logout',
  },
  logoutWarn: {
    id: `${scope}.logoutWarn`,
    defaultMessage: 'Do you want to logout?',
  },
  manageUser: {
    id: `${scope}.manageUser`,
    defaultMessage: 'Manage users',
  },
  bib: {
    id: `${scope}.bib`,
    defaultMessage: 'BIB',
  },
  confirmed: {
    id: `${scope}.confirmed`,
    defaultMessage: 'Confirmed',
  },
  dropped: {
    id: `${scope}.dropped`,
    defaultMessage: 'Dropped',
  },
  postponed: {
    id: `${scope}.postponed`,
    defaultMessage: 'Postponed',
  },
  updateTeamStatusSuccess: {
    id: `${scope}.updateTeamStatusSuccess`,
    defaultMessage: 'Team status is updated successfully',
  },
  switchRoleToAdmin: {
    id: `${scope}.switchRoleToAdmin`,
    defaultMessage: 'Switch to admin',
  },
  switchRoleToOnboarder: {
    id: `${scope}.switchRoleToOnboarder`,
    defaultMessage: 'Switch to onboarder',
  },
});
